<div class="row align-items-center minContentHeight">
  <div class="col">
    <div class="container">
      <h5 class="modal-title" i18n="Modal Titel for Activation@@verify-email.title">ALMOST FINISHED...</h5>
      <form [formGroup]="activateForm"  (ngSubmit)="onSubmit()">
        <div class="form-group text-center">
          <label i18n="Explain why verification is needed@@verify-email.explanation">
            We just need to confirm your email address, otherwise we cannot invite you to the Closed Beta of ARKHEIM - REALMS AT WAR!<br>
            <br>
            If you do not receive an email within the next hour, please also check your Spam folder.<br>
            <br>
            See you on the battlefield!
          </label><br/>


          <!-- <label>Didn't received a code yet?</label>
          <a href="#" data-toggle="modal" data-target="#registerModal" i18n="Opens Register Modal@@login.modal.link.register">Resend activation email here!</a>
          -->
        </div>
        <div class="form-group form-label-group">
          <input type="text" id="activateCodeInput" class="form-control" required  formControlName="code"  />
          <label for="activateCodeInput" i18n="Input Label@@activate.form.code.label">Activation Code</label>
          <div *ngIf="activateForm.controls.code.invalid && (activateForm.controls.code.dirty || activateForm.controls.code.touched)" class="invalid-tooltip">
            <span i18n="Error message when Terms & Conditions are not accepted@@verify-email.form.errors.toc.required">Invalid Activation Code!</span>
          </div>
        </div>
        <div class="text-center">
          <div class="btn-primary-container">
            <button type="submit" class="btn btn-primary">
              <span i18n="Activation Form Submit button@@verify-email.form.submit.label">Verify Email</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
